var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"custom-class":'user-dialog',"visible":_vm.dialogvisible,"width":"30%"},on:{"close":function($event){_vm.$emit('update:dialogvisible', false); _vm.visiblePassword=false}}},[_c(_vm.personel,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }